export const MainDrawTypeCode = 'DAYMADEDRAW';

export enum MainDrawScheduleCode {
  TUESDAY = 'TUESDAY',
  FRIDAY = 'FRIDAY',
}

export const FRIDAY = MainDrawScheduleCode.FRIDAY;
export const TUESDAY = MainDrawScheduleCode.TUESDAY;

export enum MainDrawDay {
  TUESDAY = 'TUESDAY',
  FRIDAY = 'FRIDAY',
}

export const DrawScheduleCodeDay: Record<MainDrawScheduleCode, MainDrawDay> = {
  [MainDrawScheduleCode.TUESDAY]: MainDrawDay.TUESDAY,
  [MainDrawScheduleCode.FRIDAY]: MainDrawDay.FRIDAY,
};

export enum DaymadeDrawTypePlanCode {
  PREMIUM = 'PREMIUM',
  LITE = 'LITE',
  FREE = 'FREEMIUM',
}

export enum DaymadeDrawTypePlanSubcode {
  BASE = 'BASE',
  BOOST = 'BOOST',
}
